import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { SideBar } from "../../components/SideBar";
import { useSelector } from "react-redux";

import { ReactLoaderSpinner } from "../../components/ReactLoaderSpinner/index.js";
import ModuleQuestion from "../../components/ModuleQuestion";

// services
import { useBookmarkModuleMutation } from "../../store/services/moduleServerApi";

const Module_2_1_1 = () => {
  const { pathname: pathName } = useLocation();
  const { menuItems } = useSelector((state) => state?.moduleSlice);

  const [bookmarkModule, { isLoading: isMenuLoading }] =
    useBookmarkModuleMutation();

  /* Start useEffect */
  useEffect(() => {
    bookmarkModule({ pathName });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []); // * onPageLoad
  /* End useEffect */

  return (
    <div className="row">
      {isMenuLoading && <ReactLoaderSpinner />}
      {menuItems?.id && <SideBar menuItems={[menuItems]} />}
      <div className="col-sm-8">
        <main className="module-content">
          <section>
            <h1 className="blue text-uppercase b mt-5 mb-4">
              2.4.7 Practice Case 5
            </h1>
            <p className="me-4">Estimated time to complete: 5 minutes</p>
          </section>
          <ModuleQuestion
            correctAnswer="B"
            assessmentName="practice_case_5"
            videoTranscript={
              <>
                <p>
                  <strong>AUDIO</strong>
                  <br />
                  VO: (FEMALE)
                  <br />
                </p>
                <p>
                  This is Practice Case Number 5. This is a negative scan. The
                  size and contrast have already been adjusted. Starting at the
                  bottom of the brain and moving superiorly, you will notice
                  intense uptake located here which localizes to the clivus.
                  This activity, although intense, can occur in both negative
                  and positive PET amyloid imaging cases and does not affect the
                  interpretation of the study. Moving superiorly, we enter into
                  the cerebellum, where normal gray-white contrast can be seen.
                  Again moving superiorly, we can identify focal uptake located
                  in the posterior aspect of the brain. Sometimes, the occipital
                  lobe may be overhanging, and, in a positive case, intense
                  uptake may show up here. However, in this particular case,
                  uptake here is within the bone or, more specifically, within
                  the bone marrow. The sagittal images can also help to identify
                  this activity within the bone, as can be seen here. Therefore,
                  this activity is not within the occipital lobe. As we enter
                  into the occipital lobe, the intermediate slices may show some
                  loss of gray-white contrast. However, as you move superiorly,
                  it is clear that there is normal gray-white contrast
                  throughout the temporal and occipital lobes, with clear
                  delineation of white matter tracts bilaterally. In addition,
                  as we enter into the frontal lobes, it is clear that there is
                  gray-white contrast bilaterally. White matter finger-like
                  projections can also be seen in both frontal cortices. This is
                  typical of normal gray-white contrast. As we move upwards and
                  enter into the parietal lobes, it is clear that there is
                  excellent delineation of the white matter tracts bilaterally.
                  In addition, there is no loss of gray-white contrast in the
                  posterior parietal lobes bilaterally.
                </p>
                <p>
                  This pattern can be seen as we move towards the top of the
                  brain. Again seeing normal white matter tracts, with no loss
                  of gray-white contrast. However, we can again see that there
                  is focal uptake located here within bone. In addition, mildly
                  intense uptake can also be seen within the bone and scalp here
                  and here. This is not interfering with the ability to read
                  this scan and does not affect the evaluation of gray-white
                  contrast. Therefore, this scan is negative indicating sparse
                  or no amyloid neuritic plaques.
                </p>
              </>
            }
            previousLesson="/module-2/module-2-4-6"
            nextLesson="/module-2/module-2-4-8"
            iframeURL="https://cdnapisec.kaltura.com/p/1759891/sp/175989100/embedIframeJs/uiconf_id/24639831/partner_id/1759891?iframeembed=true&playerId=kaltura_player_1960028188&entry_id=1_2pxgi9up&wid=_1759891&flashvars[sideBarContainer.plugin]=true&flashvars[sideBarContainer.position]=left&flashvars[sideBarContainer.clickToClose]=true&flashvars[chapters.plugin]=true&flashvars[chapters.layout]=vertical&flashvars[chapters.thumbnailRotator]=false&flashvars[streamSelector.plugin]=true&flashvars[EmbedPlayer.SpinnerTarget]=videoHolder&flashvars[dualScreen.plugin]=true"
            questionType="practice"
            videoId="1_2pxgi9up"
          />
        </main>
      </div>
    </div>
  );
};

export default Module_2_1_1;
